import { render, staticRenderFns } from "./BaseButtonShowMoreItems.vue?vue&type=template&id=66372ea0&scoped=true&"
import script from "./BaseButtonShowMoreItems.vue?vue&type=script&setup=true&lang=js&"
export * from "./BaseButtonShowMoreItems.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66372ea0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VChip,VList,VMenu})
